import Login from "@/features/auth/Login";

const LoginPage = () => {
  return <Login />;
};

export default LoginPage;
